/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StageGachaWithEditionRequest } from '../../models/stage-gacha-with-edition-request';
import { StageGachaWithEditionResponse } from '../../models/stage-gacha-with-edition-response';

export interface AdminServiceStageGachaWithEdition$Params {
      body: StageGachaWithEditionRequest
}

export function adminServiceStageGachaWithEdition(http: HttpClient, rootUrl: string, params: AdminServiceStageGachaWithEdition$Params, context?: HttpContext): Observable<StrictHttpResponse<StageGachaWithEditionResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceStageGachaWithEdition.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StageGachaWithEditionResponse>;
    })
  );
}

adminServiceStageGachaWithEdition.PATH = '/api/v3/gateway/admin/stage/gacha/edition';
